
  var CCF;

  (function(url, position, callback){
        url = url || 'https://ajax.googleapis.com/ajax/libs/jquery/3.7.1/jquery.min.js';
        position = position || 0;
        
        if (!window.jQuery) {
            var head = document.getElementsByTagName('head')[0];
            var script = document.createElement("script");
            script.src = url;
            script.type = 'text/javascript';
            head.appendChild(script);
            head.insertBefore(script,head.childNodes[position]);
  
            script.onload = function(){
                if(typeof callback == 'function') {
                    callback(jQuery);
                }
            };
        } else {
            if(typeof callback == 'function') {
                callback(jQuery);
            }
        }
    }('https://ajax.googleapis.com/ajax/libs/jquery/3.7.1/jquery.min.js', 5, function($){
  
        CCF = jQuery.noConflict();
        init_ccf();
    
    }));
  
// }

function init_ccf(){
  //console.log("CCF started");

  CCF(".CCF_fields").hide();

  // check if app is activate
  check_app_activated();

  
}

function validate(target, message) {
  alert(message);
  CCF(target).focus().css('outline', '1px solid #FF0000');
  return false;
}

function check_app_activated() {
  
    var request = CCF.ajax({
      url: "/apps/CCF",
      method: "POST",
      data: {action: "check_store"},
      dataType: "json",
      crossDomain: true
    }); 

    request.done(function( data ) {
      console.log(data);

      if(data.is_valid_store){
        CCF(".CCF_fields").show();
        
        set_cart_options(data);
      }
    })
  
}

function set_cart_options(data) {
  console.log("set");
 // totals__total-value
var total_price_selector = "";
var total_extra_cost = 0;
var store_currency = CCF('.store_currency').text();
var cart_total = CCF('.cart-total').text();

  
 CCF('.CCF_input').each(function(){
     var $this = CCF(this);
   
  if (CCF(this).is(':checkbox')) {
    var is_additional_cost = CCF(this).data("additional");
        var additional_type = CCF(this).data("additional-type");

      
      if(is_additional_cost!=""){
      
      if(additional_type=="fixed"){
         if (CCF(this).is(':checked')) {
         total_extra_cost = total_extra_cost+ is_additional_cost;
        }
      }else{
        
          var ct =    (Number(cart_total)/100);
          var add_cost = (ct/100) * is_additional_cost;
          if ($this.is(':checked')) {
              total_extra_cost = total_extra_cost+ add_cost;
          
          }
      
      }
       
    }
  }
   
 });


if(total_extra_cost>0){
  

  
         var last_price = (Number(cart_total))/100 + total_extra_cost;
    var price_last = store_currency.replace("{{amount}}",last_price.toFixed(2));
   CCF(total_price_selector).html(price_last);  
    
 
    
}

  
    
      
  
  CCF('.CCF_input').on('change', function(e) {
    var additional_type =  CCF(this).data("additional-type");
    var is_additional_cost =  CCF(this).data("additional");
    var $this = CCF(this);
  if (CCF(this).is(':checkbox')) {
 
      
    if(additional_type=="fixed"){
      
    }else{
       var ct =    ((Number(cart_total))/100);
       
      var add_cost = (ct/100) * Number(is_additional_cost);
      is_additional_cost = add_cost;
      
    }    
 
        if(is_additional_cost!=""){

         if ($this.is(':checked')) {
          
        total_extra_cost = total_extra_cost + is_additional_cost;
        
        }else{
          total_extra_cost = total_extra_cost - is_additional_cost;
        }
      
   
         var last_price = ((Number(cart_total)))/100 + total_extra_cost;
  var price_last = store_currency.replace("{{amount}}",last_price.toFixed(2));
   CCF(total_price_selector).html(price_last);  
 
     }

      
}});
  

  
  CCF('body').on('click', ".CCF_checkout_btn,#dvPaypal, #dvAmazon, input[name='checkout'], button[name='checkout'], [href$='checkout'], input[name='goto_pp'], button[name='goto_pp'], input[name='goto_gc'], button[name='goto_gc'], .additional-checkout-button, .google-wallet-button-holder, .amazon-payments-pay-button", function(ev){
    ev.preventDefault();
    
    if (CCF("[name='note']").length) {
      var note = CCF("[name='note']")[0].value;
    }
    if (CCF("[name='cart[note]").length) {
      var note = CCF("[name='cart[note]")[0].value;
    }

    var validate_pass = true;
    var is_additional_cost;
    var attributes_arr = {};
    var add_cost_arr = [];
    
    
    CCF('.CCF_input').not( ":radio" ).each(function(){
      
      var attr_val = CCF(this).val();
      var attr_key = CCF(this).attr("name").match(/\[(.*?)\]/);
      var key = attr_key[1];
      
      CCF(this).css('outline', 'none');
      
      // check if field is required 
      var is_required = CCF(this).data("required");
      var is_additional_cost = CCF(this).data("additional");
      var additional_type =  CCF(this).data("additional-type");

      if(additional_type=="fixed"){
           if(is_additional_cost != "" && (CCF(this).is(':checked') && CCF(this).is(':checkbox'))){
         // CCF(total_price_selector).html("<s class='wbo_disc_price'>"+ 1 +"</s> " + is_additional_cost);  
        add_cost_arr.push({ cost:  is_additional_cost, field: key});
      }
      }else{
           if(is_additional_cost != "" && (CCF(this).is(':checked') && CCF(this).is(':checkbox'))){
          
             CCF.getJSON( "/cart.js", function( cartData ) {
            
               var ct =    (cartData.total_price/100);
               var add_cost = (ct/100) * is_additional_cost;
                add_cost_arr.push({ cost:  add_cost, field: key});
             });
         

             
        }
      }
   
      
      if(is_required && attr_val == ""){
        var msg = key + " field is required"
        validate_pass = false;
        return validate(this, msg);
      }
      
      
      if (CCF(this).is(':checkbox')) {
        
      

        if (CCF(this).is(':checked')) {
          var attr_val = "yes";
        }else{
          var attr_val = "no";
          if(is_required){
            var msg = key + " field is required"
            validate_pass = false;
            return validate(this, msg);
          }
          
        }
      }

      
      
      attributes_arr[key] = attr_val;
    });

    CCF('.CCF_radio_input').each(function(){
      
      // check if field is required 
      var is_required = CCF(this).data("required");
      CCF(this).css('outline', 'none');

      var attr_key = CCF(this).find(".CCF_input").attr("name").match(/\[(.*?)\]/);
      var key = attr_key[1];
      
      if(CCF(this).find(".CCF_input").is(':checked')){
        var attr_val = CCF(this).find(".CCF_input:checked").val();
        attributes_arr[key] = attr_val;
      }else if(is_required){
        var msg = key + " field is required"
        validate_pass = false;
        return validate(this, msg);
      }
      
    });

    if(!validate_pass){
      return false;
    }

    console.log(attributes_arr); 
    // return false;
    
    
    var attributes = {
      'attributes':attributes_arr,
      'note': note
    };
    
    var request = CCF.ajax({
      url: "/cart/update.js",
      method: "POST",
      contentType: 'application/json',
      data: JSON.stringify(attributes),
      dataType: "json",
    });
    
    request.done(function( cart ) {

      if(add_cost_arr.length > 0){
        // create draft order
        create_draft_order(add_cost_arr, cart);
      }else{
        console.log("Normal");
        window.location = "/checkout";
      }

      return false;

      
    });
  }); 
}

function  create_draft_order(add_cost_arr, cart) {

  var add_cost_data = JSON.stringify(add_cost_arr);
  var cart = JSON.stringify(cart);

  var request = CCF.ajax({
      url: "/apps/CCF",
      method: "POST",
      data: {action: "create_draft_order", add_cost_data: add_cost_data, cart: cart},
      dataType: "json",
      crossDomain: true
    }); 

  request.done(function( data ) {
    console.log(data);

    if(data.success){
      window.location = data.success.invoice_url;
    }else{
      
    }

    
  })
  
}
